import { Box, Typography } from "@mui/material";
import MuiAvatar from "@mui/material/Avatar";
import styled from "styled-components";

export const UserInfoContainer = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const Avatar = styled(MuiAvatar)`
  background-color: #a0aec0;
  width: 145px;
  height: 145px;
  flex-shrink: 0;
  color: ${(props) => props.theme.text.primary};
  text-align: center;
  font-size: 28px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const ProfileWrapper = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`;

export const UserFullName = styled(Typography)`
  color: #1d1d1d;
  font-family: "NotoSans-Regular";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
`;
